import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector, ViewContainerRef, inject } from '@angular/core';
import { IQRCodeScaner } from '../_interface/IQRCodeScanner';
import type { QRCodeScannerComponent } from '../qrcode-scanner/qrcode-scanner.component';
import { Subject } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class WebQRCodeScanerService implements IQRCodeScaner {
  ref: MatDialogRef<QRCodeScannerComponent> | null = null;
  dlg: MatDialog;
  private result$?: Subject<string>;
  /** Raste na svaki start()/stop() — otkazuje otvaranje ako je stop() stigao dok se chunk učitavao. */
  private startSeq = 0;

  constructor(injector: Injector
  ) {
    this.dlg = injector.get(MatDialog);
  }


  enable(): void {
    if (this.ref) {
      this.ref.componentInstance.enabled = true;
    }
  }

  disable(): void {
    if (this.ref) {
      this.ref.componentInstance.enabled = false;
    }
  }

  get isEnabled(): boolean {
    return this.ref?.componentInstance.enabled ?? false;
  };

  setBusy(busy: boolean): void {
    if (this.ref) {
      this.ref.componentInstance.busy = busy;
    }
  }

  scan() {
    return this.result$;
  }

  stop(): void {
    this.startSeq++;
    this.result$?.complete();
    this.ref?.close();
  }

  start() {
    const seq = ++this.startSeq;
    const result$ = this.result$ = new Subject<string>();

    // Komponenta skenera (sa @zxing bibliotekom) je standalone i učitava se tek ovde —
    // lazy chunk umesto inicijalnog bundle-a. result$ se vraća odmah (sinhroni API).
    import('../qrcode-scanner/qrcode-scanner.component').then(({ QRCodeScannerComponent }) => {
      if (seq !== this.startSeq || result$ !== this.result$) {
        return; // stop()/novi start() dok se chunk učitavao
      }

      this.ref = this.dlg.open(QRCodeScannerComponent, {
        panelClass: ['emeni-dialog', 'emeni-fullscreen'],
        autoFocus: false,
      });
      this.ref.componentInstance.scanCompleted.subscribe(
        {
          next: (result: string) => {
            result$.next(result);
          }
          ,
          error: (error: any) => {
            result$.error(error);
          }
        });

      // Dismissing the scanner (close button / Esc) must complete the stream so the
      // caller isn't left subscribed to a dialog that no longer exists.
      this.ref.afterClosed().subscribe(() => {
        result$.complete();
        this.ref = null;
      });
    });

    return result$;
  }
}
